// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrelanderV3Page__container--UFwyu {
    position: relative;
    background-color: #07080B;
    width: 100%;
    min-height: 100vh;
    min-height: calc(var(--vh) * 100);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
}

    @media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {.PrelanderV3Page__container--UFwyu {
        min-height: 100vh
}
    }

.PrelanderV3Page__headerWrapper--ld3p2 {
    width: 100%;
    border-bottom: 1px solid var(--dark-secondary-new-color);
    background-color: var(--dark-primary-new-color);
}

.PrelanderV3Page__header--h6riI {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1024px;
    margin: 0 auto;
    padding: 16px 0;
}

@media screen and (max-width: 1023px) {

.PrelanderV3Page__header--h6riI {
        padding: 16px
}
    }

.PrelanderV3Page__headerMainInformation--sfgN4 {
    display: flex;
    align-items: center;
    gap: 24px;
}

@media screen and (min-width: 1024px) {

.PrelanderV3Page__headerMainInformation--sfgN4 {
        gap: 32px
}
    }

.PrelanderV3Page__headerTitle--jrVSh {
    color: #646979;
    font-size: 10px;
    font-weight: 500;
    line-height: 12px;
    border-left: 1px solid #646979;
    padding-left: 8px;
}

@media screen and (min-width: 1024px) {

.PrelanderV3Page__headerTitle--jrVSh {
        font-size: 12px;
        line-height: 16px;
        padding-left: 16px
}
    }

.PrelanderV3Page__logo--X2PUV > img {
        width: 103px;
        height: 24px;
    }

.PrelanderV3Page__main--K9mzR {
    max-width: 1024px;
    margin: 0 auto;
    text-align: center;
}

@media screen and (max-width: 1023px) {

.PrelanderV3Page__mainWithIndent--O2za4 {
        padding: 0 16px
}
    }

.PrelanderV3Page__label--YsHsz {
    display: block;
    color: var(--secondary-color);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

.PrelanderV3Page__title--GzU63 {
    color: var(--tertiary-color);
    font-size: 20px;
    font-weight: 900;
    line-height: 24px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

.PrelanderV3Page__secondaryTitle--RYX8L {
    color: var(--tertiary-color);
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: 0.16px;
    text-transform: uppercase;
    margin-bottom: 24px;
}

@media screen and (min-width: 1024px) {

.PrelanderV3Page__secondaryTitle--RYX8L {
        font-size: 20px;
        line-height: 1.4;
        letter-spacing: 0.2px;
        margin-bottom: 28px
}
    }

.PrelanderV3Page__titleWithIndent--l3Ucs {
    margin-bottom: 28px;
}

.PrelanderV3Page__smallDescription--Lt_jR {
    color: var(--tertiary-color);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-transform: uppercase;
}

.PrelanderV3Page__description--qLz4O {
    color: var(--premium-solid-color);
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.16px;
    text-transform: uppercase;
    padding: 0 16px;
    max-width: 640px;
    margin: 0 auto;
}

.PrelanderV3Page__description--qLz4O > strong {
        font-weight: 900;
    }

@media screen and (min-width: 1024px) {

.PrelanderV3Page__description--qLz4O {
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 0.2px
}
    }

.PrelanderV3Page__image--W6TR7 {
    width: 100%;
    height: auto;
    aspect-ratio: 1.8;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
}

@media screen and (min-width: 1024px) {

.PrelanderV3Page__image--W6TR7 {
        aspect-ratio: 1.91
}
    }

.PrelanderV3Page__rewardBlock--pHEPv {
    position: relative;
}

.PrelanderV3Page__rewardImage--AH7ly {
    width: 100%;
    height: auto;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
    aspect-ratio: 1.8;
}

@media screen and (min-width: 1024px) {

.PrelanderV3Page__rewardImage--AH7ly {
        aspect-ratio: 1.91
}
    }

.PrelanderV3Page__ratingImage--Gx8aL {
    position: absolute;
    bottom: 28px;
    right: 16px;
    transform: rotate(15deg);
    width: 67px;
    height: auto;
}

@media screen and (min-width: 1024px) {

.PrelanderV3Page__ratingImage--Gx8aL {
        bottom: 54px;
        left: 50%;
        right: unset;
        transform: translateX(calc(-50% + 198px))
}
    }

.PrelanderV3Page__ratingDescription--Mdat1 {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 328px;
    color: var(--warning-color);
    font-size: 12px;
    font-style: italic;
    text-align: center;
    font-weight: 900;
    line-height: 16px;
    letter-spacing: 0.12px;
    text-transform: uppercase;
}

@media screen and (min-width: 1024px) {

.PrelanderV3Page__ratingDescription--Mdat1 {
        font-size: 20px;
        line-height: 28px;
        letter-spacing: 0.2px;
        bottom: 33px
}
    }

.PrelanderV3Page__button--9dxob {
    margin: 0 auto;
    width: 100%;
    max-width: 200px;
    display: flex;
}

.PrelanderV3Page__footer--CFNdu {
    padding-bottom: 16px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderV3Page__footer--CFNdu {
        padding-bottom: 24px
}
    }

.PrelanderV3Page__copyrightText--pQR1y {
    color: var(--dark-fourth-new-color);
    text-align: center;
    font-size: 8px;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: 0.08px;
    text-transform: uppercase;
}

@media screen and (max-width: 1023px) {

.PrelanderV3Page__copyrightText--pQR1y {
        padding: 0 16px
}
    }

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderV3Page__copyrightText--pQR1y {
        margin: 0 auto;
        max-width: 604px;
        font-size: 10px;
        line-height: 16px;
        letter-spacing: 0.1px
}
    }

@media screen and (max-width: 1023px) {

.PrelanderV3Page__hiddenOnMobile--GaNnf {
        display: none
}
    }
`, "",{"version":3,"sources":["webpack://./src/pages/PrelanderV3Page/PrelanderV3Page.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;AAKb;;IAHI,8FAXJ;QAYQ;AAER;IADI;;AAGJ;IACI,WAAW;IACX,wDAAwD;IACxD,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;AAKnB;;AAHI;;AARJ;QASQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AAKb;;AAHI;;AALJ;QAMQ;AAER;IADI;;AAGJ;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;AAOrB;;AALI;;AARJ;QASQ,eAAe;QACf,iBAAiB;QACjB;AAER;IADI;;AAIA;QACI,YAAY;QACZ,YAAY;IAChB;;AAGJ;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAGI;;AADJ;QAEQ;AAER;IADI;;AAGJ;IACI,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AAQvB;;AANI;;AAVJ;QAWQ,eAAe;QACf,gBAAgB;QAChB,qBAAqB;QACrB;AAER;IADI;;AAGJ;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAYlB;;AAVI;QACI,gBAAgB;IACpB;;AAEA;;AAhBJ;QAiBQ,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB;AAER;IADI;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;AAK3B;;AAHI;;AAPJ;QAQQ;AAER;IADI;;AAGJ;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;IACvB,iBAAiB;AAKrB;;AAHI;;AAPJ;QAQQ;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,WAAW;IACX,YAAY;AAQhB;;AANI;;AARJ;QASQ,YAAY;QACZ,SAAS;QACT,YAAY;QACZ;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAQ7B;;AANI;;AAhBJ;QAiBQ,eAAe;QACf,iBAAiB;QACjB,qBAAqB;QACrB;AAER;IADI;;AAGJ;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,oBAAoB;AAKxB;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,mCAAmC;IACnC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAa7B;;AAXI;;AATJ;QAUQ;AAUR;IATI;;AAEA;;AAbJ;QAcQ,cAAc;QACd,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB;AAER;IADI;;AAIA;;AADJ;QAEQ;AAER;IADI","sourcesContent":[".container {\n    position: relative;\n    background-color: #07080B;\n    width: 100%;\n    min-height: 100vh;\n    min-height: calc(var(--vh) * 100);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 24px;\n\n    @media (--large), (--small-tablet) {\n        min-height: 100vh;\n    }\n}\n\n.headerWrapper {\n    width: 100%;\n    border-bottom: 1px solid var(--dark-secondary-new-color);\n    background-color: var(--dark-primary-new-color);\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 1024px;\n    margin: 0 auto;\n    padding: 16px 0;\n\n    @media (--mobile) {\n        padding: 16px;\n    }\n}\n\n.headerMainInformation {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n\n    @media (--large) {\n        gap: 32px;\n    }\n}\n\n.headerTitle {\n    color: #646979;\n    font-size: 10px;\n    font-weight: 500;\n    line-height: 12px;\n    border-left: 1px solid #646979;\n    padding-left: 8px;\n\n    @media (--large) {\n        font-size: 12px;\n        line-height: 16px;\n        padding-left: 16px;\n    }\n}\n\n.logo {\n    > img {\n        width: 103px;\n        height: 24px;\n    }\n}\n\n.main {\n    max-width: 1024px;\n    margin: 0 auto;\n    text-align: center;\n}\n\n.mainWithIndent {\n    @media (--mobile) {\n        padding: 0 16px;\n    }\n}\n\n.label {\n    display: block;\n    color: var(--secondary-color);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n}\n\n.title {\n    color: var(--tertiary-color);\n    font-size: 20px;\n    font-weight: 900;\n    line-height: 24px;\n    letter-spacing: 0.2px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n}\n\n.secondaryTitle {\n    color: var(--tertiary-color);\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.25;\n    letter-spacing: 0.16px;\n    text-transform: uppercase;\n    margin-bottom: 24px;\n\n    @media (--large) {\n        font-size: 20px;\n        line-height: 1.4;\n        letter-spacing: 0.2px;\n        margin-bottom: 28px;\n    }\n}\n\n.titleWithIndent {\n    margin-bottom: 28px;\n}\n\n.smallDescription {\n    color: var(--tertiary-color);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n    text-transform: uppercase;\n}\n\n.description {\n    color: var(--premium-solid-color);\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0.16px;\n    text-transform: uppercase;\n    padding: 0 16px;\n    max-width: 640px;\n    margin: 0 auto;\n\n    > strong {\n        font-weight: 900;\n    }\n\n    @media (--large) {\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 28px;\n        letter-spacing: 0.2px;\n    }\n}\n\n.image {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1.8;\n    object-fit: contain;\n    object-position: center;\n\n    @media (--large) {\n        aspect-ratio: 1.91;\n    }\n}\n\n.rewardBlock {\n    position: relative;\n}\n\n.rewardImage {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    object-position: center;\n    aspect-ratio: 1.8;\n\n    @media (--large) {\n        aspect-ratio: 1.91;\n    }\n}\n\n.ratingImage {\n    position: absolute;\n    bottom: 28px;\n    right: 16px;\n    transform: rotate(15deg);\n    width: 67px;\n    height: auto;\n\n    @media (--large) {\n        bottom: 54px;\n        left: 50%;\n        right: unset;\n        transform: translateX(calc(-50% + 198px));\n    }\n}\n\n.ratingDescription {\n    position: absolute;\n    bottom: 16px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    max-width: 328px;\n    color: var(--warning-color);\n    font-size: 12px;\n    font-style: italic;\n    text-align: center;\n    font-weight: 900;\n    line-height: 16px;\n    letter-spacing: 0.12px;\n    text-transform: uppercase;\n\n    @media (--large) {\n        font-size: 20px;\n        line-height: 28px;\n        letter-spacing: 0.2px;\n        bottom: 33px;\n    }\n}\n\n.button {\n    margin: 0 auto;\n    width: 100%;\n    max-width: 200px;\n    display: flex;\n}\n\n.footer {\n    padding-bottom: 16px;\n\n    @media (--large), (--small-tablet) {\n        padding-bottom: 24px;\n    }\n}\n\n.copyrightText {\n    color: var(--dark-fourth-new-color);\n    text-align: center;\n    font-size: 8px;\n    font-weight: 500;\n    line-height: 12px;\n    letter-spacing: 0.08px;\n    text-transform: uppercase;\n\n    @media (--mobile) {\n        padding: 0 16px;\n    }\n\n    @media (--large), (--small-tablet) {\n        margin: 0 auto;\n        max-width: 604px;\n        font-size: 10px;\n        line-height: 16px;\n        letter-spacing: 0.1px;\n    }\n}\n\n.hiddenOnMobile {\n    @media (--mobile) {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PrelanderV3Page__container--UFwyu`,
	"headerWrapper": `PrelanderV3Page__headerWrapper--ld3p2`,
	"header": `PrelanderV3Page__header--h6riI`,
	"headerMainInformation": `PrelanderV3Page__headerMainInformation--sfgN4`,
	"headerTitle": `PrelanderV3Page__headerTitle--jrVSh`,
	"logo": `PrelanderV3Page__logo--X2PUV`,
	"main": `PrelanderV3Page__main--K9mzR`,
	"mainWithIndent": `PrelanderV3Page__mainWithIndent--O2za4`,
	"label": `PrelanderV3Page__label--YsHsz`,
	"title": `PrelanderV3Page__title--GzU63`,
	"secondaryTitle": `PrelanderV3Page__secondaryTitle--RYX8L`,
	"titleWithIndent": `PrelanderV3Page__titleWithIndent--l3Ucs`,
	"smallDescription": `PrelanderV3Page__smallDescription--Lt_jR`,
	"description": `PrelanderV3Page__description--qLz4O`,
	"image": `PrelanderV3Page__image--W6TR7`,
	"rewardBlock": `PrelanderV3Page__rewardBlock--pHEPv`,
	"rewardImage": `PrelanderV3Page__rewardImage--AH7ly`,
	"ratingImage": `PrelanderV3Page__ratingImage--Gx8aL`,
	"ratingDescription": `PrelanderV3Page__ratingDescription--Mdat1`,
	"button": `PrelanderV3Page__button--9dxob`,
	"footer": `PrelanderV3Page__footer--CFNdu`,
	"copyrightText": `PrelanderV3Page__copyrightText--pQR1y`,
	"hiddenOnMobile": `PrelanderV3Page__hiddenOnMobile--GaNnf`
};
export default ___CSS_LOADER_EXPORT___;
